import { render, staticRenderFns } from "./SectorReport.vue?vue&type=template&id=6bfc0aa5&scoped=true"
import script from "./SectorReport.vue?vue&type=script&lang=js"
export * from "./SectorReport.vue?vue&type=script&lang=js"
import style0 from "./SectorReport.vue?vue&type=style&index=0&id=6bfc0aa5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfc0aa5",
  null
  
)

export default component.exports